import { render, staticRenderFns } from "./CheckoutApproved.vue?vue&type=template&id=2dd2df22&scoped=true"
import script from "./CheckoutApproved.vue?vue&type=script&lang=js"
export * from "./CheckoutApproved.vue?vue&type=script&lang=js"
import style0 from "./CheckoutApproved.vue?vue&type=style&index=0&id=2dd2df22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2df22",
  null
  
)

export default component.exports